module.exports = __webpack_public_path__ + "img/lezhi01.f177ebe5.png";